import Repository from "./masterRepository";
const GET_EXTENSIONS = "get";
const ADD_EXTENSIONS = "add";
const EDIT_EXTENSIONS = "edit";
const DELETE_EXTENSIONS = "delete";
const CREATE_EXTENSION_ORDER = "createExtensionOrder";
const ADD_EXTENSION_REQUEST = "add";
const GET_EXTENSION_REQUEST = "get";
const EMAIL_TRIGGRED = "mailTriggred";

export default {
  getExtensions(payload) {
    return Repository.post(transformRoute(GET_EXTENSIONS), payload);
  },
  addExtensions(payload) {
    return Repository.post(transformRoute(ADD_EXTENSIONS), payload);
  },
  editExtensions(payload) {
    return Repository.post(transformRoute(EDIT_EXTENSIONS), payload);
  },
  deleteExtensions(payload) {
    return Repository.post(transformRoute(DELETE_EXTENSIONS), payload);
  },
  createExtensionOrder(payload) {
    return Repository.post(transformRoute1(CREATE_EXTENSION_ORDER), payload);
  },
  addExtensionRequest(payload) {
    return Repository.post(transformRoute1(ADD_EXTENSION_REQUEST), payload);
  },
  mailTriggred(payload) {
    return Repository.post(transformRoute1(EMAIL_TRIGGRED), payload);
  },
  getExtensionRequest(payload) {
    return Repository.post(transformRoute1(GET_EXTENSION_REQUEST), payload);
  },
};
const transformRoute = (route) => {
  return `/extensions/${route}`;
};
const transformRoute1 = (route) => {
  return `/extensionsRequest/${route}`;
};
